/* eslint-disable */
import { useEffect, useState } from 'react';

/**
 * useTranslation
 * @param {any} services The services
 * @param {any} i18nKey The i18nKey
 * @param {any} data The data
 * @returns {string} The component
 */
const useTranslation = (services, i18nKey, data) => {
  const [translatedValue, setTranslatedValue] = useState(``);

  /**
   * getTranslation
   * @returns {void} void
   */
  const getTranslation = async () => {
    if (services) {
      const translation = await services.i18nService.getTranslation(i18nKey, data);
      setTranslatedValue(translation);
    }
  };

  useEffect(() => {
    getTranslation();
  });

  return translatedValue;
};

export default useTranslation;
